// extracted by mini-css-extract-plugin
export default {"CancelButton":"CancelButton_CancelButton__BlXSf","CancelButton__Caption":"CancelButton_CancelButton__Caption__lM9QR","CancelButton__Icon":"CancelButton_CancelButton__Icon__X-NYR"};